import { Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppCommonModule } from '@app/components/app.common.module';
import { BaseComponent } from '@app/components/base/base.component';
import { ModalService } from '@app/components/modal/modal.service';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { RegionDrmFormModalComponent } from './region-drm-form-modal/region-drm-form-modal.component';
import {
  RegionDrmCatalogItem,
  RegionDrmCatalogService,
} from './region-drm-catalog.service';

@Component({
  selector: 'app-list-region-drm-catalog',
  standalone: true,
  imports: [AppCommonModule, RegionDrmFormModalComponent],
  templateUrl: './list-region-drm-catalog.component.html',
  styleUrl: './list-region-drm-catalog.component.scss',
})
export class ListRegionDrmCatalogComponent extends BaseComponent implements OnInit {
  @ViewChild('template') template!: TemplateRef<unknown>;
  @ViewChild('modalForm') modalForm!: TemplateRef<unknown>;
  @ViewChild('templateConfirmation') templateConfirmation!: TemplateRef<unknown>;

  isLoading = false;
  hasData = false;
  data: RegionDrmCatalogItem[] = [];
  reset = false;

  isEditModal = false;
  editingId: number | null = null;
  modalOpenKey = 0;

  title = 'Eliminar región / zona';
  subtitle = '';
  btn1 = 'Cancelar';
  btn2 = 'Eliminar';
  deleteId: number | null = null;

  searchRegion: { placeholder: string; value: string } = {
    placeholder: 'Buscar por región o zona',
    value: '',
  };

  segmentOptions = [
    { label: 'Todos', value: null },
    { label: 'Carga', value: 'CARGA' },
    { label: 'Pasaje', value: 'AUTOBUSES' },
  ];

  selectedSegment: { label: string; value: string | null } | null = null;

  private readonly catalogService = inject(RegionDrmCatalogService);
  private readonly modalService = inject(ModalService);

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
    this.sendDataToMenu();
  }

  ngOnInit(): void {
    this.getList();
  }

  getList(): void {
    this.isLoading = true;
    this.catalogService
      .list({
        segment: this.selectedSegment?.value ?? null,
        regionName: this.searchRegion.value?.trim() || null,
      })
      .subscribe({
        next: (response) => {
          const items = response?.data ?? [];
          this.data = [...items].sort((a, b) =>
            a.regionName.localeCompare(b.regionName, 'es'),
          );
          this.hasData = this.data.length > 0;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.hasData = false;
          this.data = [];
        },
      });
  }

  openCreate(): void {
    this.isEditModal = false;
    this.editingId = null;
    this.modalOpenKey++;
    this.modalService.component = this.modalForm;
    this.modalService.openModal();
  }

  openEdit(item: RegionDrmCatalogItem): void {
    this.isEditModal = true;
    this.editingId = item.id;
    this.modalOpenKey++;
    this.modalService.component = this.modalForm;
    this.modalService.openModal();
  }

  onSaved(): void {
    this.showNotificationSuccess(
      this.isEditModal ? 'Región/zona actualizada.' : 'Región/zona creada.',
    );
    this.getList();
  }

  openDeleteConfirm(item: RegionDrmCatalogItem): void {
    this.deleteId = item.id;
    this.subtitle = `¿Confirma la eliminación de "${item.regionName}" (${this.segmentLabel(item.segment)})?`;
    this.modalService.component = this.templateConfirmation;
    this.modalService.openModal();
  }

  confirmDelete(): void {
    if (this.deleteId == null) {
      return;
    }
    this.isLoading = true;
    this.catalogService.delete(this.deleteId).subscribe({
      next: () => {
        this.closeModal();
        this.showNotificationSuccess('Región/zona eliminada.');
        this.getList();
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

  search(): void {
    this.getList();
  }

  resetFilters(): void {
    this.reset = true;
    this.searchRegion = { placeholder: 'Buscar por región o zona', value: '' };
    this.selectedSegment = null;
    this.getList();
  }

  filterRegion(value: string): void {
    this.searchRegion = { ...this.searchRegion, value };
  }

  filterSegment(value: string | null): void {
    this.selectedSegment =
      this.segmentOptions.find((o) => o.value === value) ?? null;
  }

  segmentLabel(segment: string): string {
    return segment === 'CARGA' ? 'Carga' : 'Pasaje';
  }
}
